import { useBemCN } from '@gik/core/utils/bemBlock';
import { DeterminationType, LoadingLinear } from '@gik/ui';
import React from 'react';

interface ICreatingPageIndicatorProps {
  progress: number;
}

export function CreatingPageIndicator({ progress }: ICreatingPageIndicatorProps) {
  const bem = useBemCN('creating-page-indicator');

  return (
    <div {...bem()}>
      <p {...bem('message')}>Please wait while we create your page...</p>
      <LoadingLinear type={DeterminationType.Determinate} percentComplete={(progress / 8.0) * 100} />
    </div>
  );
}
